import React from 'react';
import { BadgeCheck } from 'lucide-react';

const HERTALAN = 'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/1gjn7n6r_hertalan.jpg';
const RESITRIX = 'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/tauie7oe_rysiek%20grafika.gif';

const CertifiedBy = () => {
  return (
    <section className="bg-[#0b0b0b] border-t border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-10 md:py-12">
        <div className="grid lg:grid-cols-[auto_1fr] gap-8 lg:gap-12 items-center">
          {/* Caption */}
          <div className="flex items-start lg:items-center gap-4">
            <BadgeCheck size={36} className="text-[#e30613] shrink-0" strokeWidth={1.4} />
            <div>
              <p className="text-[10.5px] tracking-[0.28em] text-white/55 font-bold">CERTYFIKACJA</p>
              <p className="text-[14px] md:text-[15px] text-white font-semibold mt-1.5 leading-snug max-w-[420px]">
                Certyfikowany wykonawca systemów hydroizolacyjnych
              </p>
            </div>
          </div>

          {/* Vertical separator on lg */}
          <div className="hidden lg:block absolute" />

          {/* Logos */}
          <div className="flex flex-wrap items-stretch justify-center lg:justify-end gap-5 sm:gap-6 lg:border-l lg:border-white/10 lg:pl-12">
            <div className="bg-black border border-white/10 px-8 py-6 flex items-center justify-center min-w-[260px] h-[140px]">
              <img
                src={HERTALAN}
                alt="HERTALAN — certyfikowany wykonawca"
                className="max-h-full max-w-[200px] object-contain"
                style={{ filter: 'invert(1) hue-rotate(180deg)' }}
                loading="lazy"
              />
            </div>

            <div className="bg-[#3d3d3d] border border-white/10 px-8 py-6 flex items-center justify-center min-w-[260px] h-[140px]">
              <img
                src={RESITRIX}
                alt="RESITRIX — certyfikowany wykonawca"
                className="max-h-full max-w-[260px] object-contain"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertifiedBy;
